import { status } from 'skin/event/status'
import { message } from 'skin/event'

const save = (obj) => {
	message('Сохранение не активно', 'Приложение', null, '!')
	return status.ignore
}

export default save
